import i18n, { numberLocale } from "lang";

// ApexCharts reads its menu texts (Download SVG, PNG, CSV) and month and day names from a
// locale. One locale named "app" is kept in the page wide defaults (window.Apex) and rebuilt
// in the current language whenever it changes, so every chart drawn afterwards follows it.
const LOCALE_NAME = "app";

const names = (locale, part, style, count, dateOf) => {
  const format = new Intl.DateTimeFormat(locale, { [part]: style, timeZone: "UTC" });
  return Array.from({ length: count }, (_, i) => format.format(dateOf(i)));
};

const buildLocale = () => {
  const locale = numberLocale();
  const month = (i) => new Date(Date.UTC(2021, i, 1));
  const day = (i) => new Date(Date.UTC(2021, 0, 3 + i));
  return {
    name: LOCALE_NAME,
    options: {
      months: names(locale, "month", "long", 12, month),
      shortMonths: names(locale, "month", "short", 12, month),
      days: names(locale, "weekday", "long", 7, day),
      shortDays: names(locale, "weekday", "short", 7, day),
      toolbar: {
        exportToSVG: i18n.t("ChartDownloadSvg"),
        exportToPNG: i18n.t("ChartDownloadPng"),
        exportToCSV: i18n.t("ChartDownloadCsv"),
        menu: i18n.t("ChartMenu"),
        selection: i18n.t("ChartSelection"),
        selectionZoom: i18n.t("ChartSelectionZoom"),
        zoomIn: i18n.t("ChartZoomIn"),
        zoomOut: i18n.t("ChartZoomOut"),
        pan: i18n.t("ChartPan"),
        reset: i18n.t("ChartResetZoom"),
      },
    },
  };
};

export const applyChartLocale = () => {
  if (typeof window === "undefined") return;
  const current = window.Apex || {};
  window.Apex = {
    ...current,
    chart: { ...(current.chart || {}), locales: [buildLocale()], defaultLocale: LOCALE_NAME },
  };
};

applyChartLocale();
i18n.on("languageChanged", applyChartLocale);
i18n.on("loaded", applyChartLocale);
